import React from "react"
import "twin.macro"
import { graphql, useStaticQuery } from "gatsby"
import {
  GatsbyImage,
  getImage,
  IGatsbyImageData,
  ImageDataLike,
} from "gatsby-plugin-image"
type datatype = {
  allCompaniesJson: {
    nodes: {
      images: ImageDataLike
    }[]
  }
}
const CompaniesSection = () => {
  const data1: datatype = useStaticQuery(graphql`
    query MyCompanyQuery {
      allCompaniesJson {
        nodes {
          images {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  `)
  return (
    <div tw="flex flex-wrap content-center mb-24 mt-0 p-5">
      <div tw=" mx-auto text-5xl font-extrabold">
        <p>Trusted by thousands of companies</p>
      </div>
      <div tw=" mx-auto text-xl mt-4 font-extralight ">
        Aliquam a augue suscipit, luctus neque purus ipsum neque dolor primis
        libe tempus, tempor posuere ligula varius augue luctus donec volutpat
        sapien lemma ronaldo mesi best fifa worl rusliga dus akdsa atsf akla
        ksal dsius virat indjs inda bharata mahabty dasdjhk sgdd
      </div>
      <div tw="mt-12 grid  grid-cols-4 gap-4 mx-auto">
        {" "}
        {data1.allCompaniesJson.nodes.map((item, index) => {
          const image1 = getImage(item.images)
          return (
            <div>
              <GatsbyImage image={image1 as IGatsbyImageData} alt="pic" />
            </div>
          ) // now why it is not happening?
        })}
      </div>
    </div>
  )
}

export default CompaniesSection
